import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { chartDrawn } from "./../../../utilities/charts";
import { Typography } from "material-ui";

const fakeData = [
  {
    Unidad: "TRA01",
    ExcesosVelocidad: 10
  },
  {
    Unidad: "TRA02",
    ExcesosVelocidad: 10
  },
  {
    Unidad: "TRA03",
    ExcesosVelocidad: 10
  },
  {
    Unidad: "TRA04",
    ExcesosVelocidad: 20
  },
  {
    Unidad: "TRA05",
    ExcesosVelocidad: 1
  },
  {
    Unidad: "TRA06",
    ExcesosVelocidad: 11
  },
  {
    Unidad: "TRA07",
    ExcesosVelocidad: 15
  },
  {
    Unidad: "TRA08",
    ExcesosVelocidad: 0
  },
  {
    Unidad: "TRA09",
    ExcesosVelocidad: 5
  }
];

const SpeedingsChartTile = props => {
  const { lang, data, units } = props;
  const speedings = data.ExcesosVelocidad.map(v => {
    return {
      Unidad:
        units.filter(u => u.Unidad === v.Unidad).length > 0
          ? units.filter(u => u.Unidad === v.Unidad)[0].Descripcion
          : "no name",
      ExcesosVelocidad: v.Ubicaciones.length
    };
  }).filter(ev => {
    return ev.ExcesosVelocidad > 0;
  });
  return (
    <div className="dashboard-tile">
      <div className="tile-header">{lang.ExcesosVelocidad}</div>
      {speedings.length > 0 ? (
        <SpeedingsChart data={speedings} lang={lang} />
      ) : (
        <div className="tile-body" style={{ marginTop: "2rem" }}>
          <Typography variant="display1" align="center">
            {lang.SinDatosAMostrar}
          </Typography>
        </div>
      )}
    </div>
  );
};

const SpeedingsChart = props => {
  const { data, lang } = props;

  const config = {
    type: "serial",
    theme: "light",
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    dataProvider: data,
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: lang.ExcesosVelocidad
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] </b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "ExcesosVelocidad"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      options={config}
      style={{
        width: "100%",
        height: "12rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
    />
  );
};

export default SpeedingsChartTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/SpeedingsChartTile.js